import { Edit } from "@mui/icons-material";
import { Box, IconButton, TextField } from "@mui/material";
import DrawerWrapper from "components/DrawerWrapper";
import { useEffect, useState } from "react";
import SelectService from "./selectService";
import { DesktopDatePicker } from "@mui/lab";
import { handleKeyDown } from "utils/keyDownPrevent";
import { StyledTextField } from "views/task-view/Details/Fields";
import { DateTypes } from "data/constants";
import moment from "moment";
import LoadingButton from "components/LoadingButton";
import { useMutation, useQueryClient } from "react-query";
import { addRequestTask, editRequestTask } from "api/services/tasks";
import { snack } from "components/toast";

const createTaskDefaultValues = {
    service: null,
    dueDate: "",
    description: "",
    uploadDocs: null,
};

function EditTask({ open, setOpen, editData }: any) {
    const [state, setState] = useState<any>(editData || createTaskDefaultValues);
    const [error, setError] = useState<string | null>(null);
    const clientId = localStorage.getItem("clientId") || "";
    const [opendServiceDialog, setOpenServiceDialog] = useState(false);
    const [isDatePickerOpen, setIsDatePickerOpen] = useState<any[]>([false]);
    const [forFocus, setForFocus] = useState<Boolean[]>([true]);
    const queryClient = useQueryClient();

    useEffect(() => {
        setState(editData || createTaskDefaultValues);
    }, [open]);

    const handleFocus = (type: DateTypes) => {
        if (type === DateTypes.STATUTORY_DATE) {
            if (forFocus[0]) {
                const newIsDatePickerOpen = [...isDatePickerOpen];
                newIsDatePickerOpen[0] = true;
                setIsDatePickerOpen(newIsDatePickerOpen);
                const newForFocus = [...forFocus];
                newForFocus[0] = true;
                setForFocus(newForFocus);
            }
        }
    };

    const handleSelect = (type: DateTypes) => {
        const newIsDatePickerOpen = [...isDatePickerOpen];
        const newForFocus = [...forFocus];

        if (type === DateTypes.STATUTORY_DATE) {
            newIsDatePickerOpen[0] = false;
            newForFocus[0] = false;
        }

        setIsDatePickerOpen(newIsDatePickerOpen);
        setForFocus(newForFocus);
    };

    const setIsDatePickerOpenHandle = (type: DateTypes) => {
        const newIsDatePickerOpen = [...isDatePickerOpen];
        if (type === DateTypes.STATUTORY_DATE) {
            newIsDatePickerOpen[0] = true;
        }
        setIsDatePickerOpen(newIsDatePickerOpen);
    };

    const { mutate, isLoading } = useMutation(editRequestTask, {
        onSuccess: () => {
            snack.success("Requested Task Edited Successfully");
            setState(createTaskDefaultValues);
            setOpen(false);
            queryClient.invalidateQueries("requested-tasks");
        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });

    const handleSubmit = () => {
        if (!state.dueDate) {
            snack.error("Please select a due date");
            return;
        }
        mutate({
            id: state.id,
            serviceId: state.service?.id,
            dueDate: state.dueDate,
            description: state.description,
            clientId: clientId,
        });
    };
    console.log("state", state);
    return (
        <DrawerWrapper
            open={open}
            setOpen={() => {
                setState(createTaskDefaultValues);
                setOpen(false);
            }}
            title="Task Request Edit"
        >
            <Box display="flex" flexDirection="column" gap={2} mt={1}>
                <TextField
                    fullWidth
                    variant="outlined"
                    value={state.service?.name || ""}
                    placeholder="Select Service"
                    error={!!error}
                    helperText={error}
                    onClick={() => setOpenServiceDialog(true)}
                    InputProps={{
                        readOnly: true,
                        endAdornment: state.service ? (
                            <IconButton size="small" onClick={() => setOpen(true)}>
                                <Edit fontSize="small" />
                            </IconButton>
                        ) : null,
                    }}
                    sx={{
                        cursor: "pointer",
                        "& input": {
                            cursor: "pointer",
                        },
                    }}
                />
                <DesktopDatePicker
                    inputFormat="dd-MM-yyyy"
                    value={state.dueDate || null}
                    onChange={(v: any) => {
                        let date = moment(v).format("YYYY-MM-DD");
                        setState({ ...state, dueDate: date });
                        handleSelect(DateTypes.STATUTORY_DATE);
                    }}
                    open={isDatePickerOpen[0]}
                    renderInput={(params) => (
                        <StyledTextField
                            fullWidth
                            size="small"
                            {...params}
                            onKeyDown={handleKeyDown}
                            onClick={() => {
                                setIsDatePickerOpenHandle(DateTypes.STATUTORY_DATE);
                            }}
                            onFocus={() => handleFocus(DateTypes.STATUTORY_DATE)}
                            autoComplete="off"
                            sx={{
                                border: "1px solid rgba(0,0,0,0.2)",
                                borderRadius: 1,
                            }}
                        />
                    )}
                />
                <TextField
                    label="Notes"
                    placeholder="Write your notes here..."
                    rows={3}
                    multiline
                    variant="outlined"
                    fullWidth
                    value={state.notes}
                    onChange={(e) => setState({ ...state, notes: e.target.value })}
                />
                <LoadingButton
                    loading={isLoading}
                    disabled={isLoading}
                    fullWidth
                    onClick={() => handleSubmit()}
                    loadingColor="white"
                    title="Request Task"
                    color="secondary"
                    type="submit"
                />
            </Box>
            <SelectService
                open={opendServiceDialog}
                setOpen={setOpenServiceDialog}
                formState={state}
                setFormState={setState}
            />
        </DrawerWrapper>
    );
}

export default EditTask;